import { useState, useEffect } from 'react';

export const useLaunchStatus = () => {
  const [isLaunched, setIsLaunched] = useState(false);

  useEffect(() => {
    const checkLaunchStatus = () => {
      const now = new Date();
      const currentYear = now.getFullYear();
      
      // Sett til 11. oktober 2025 kl. 12:00 (7 dager fra 4. oktober)
      const launchDate = new Date(2025, 9, 11, 12, 0, 0); // måned 9 = oktober (0-indeksert)
      
      setIsLaunched(now >= launchDate);
    };

    checkLaunchStatus();
    const timer = setInterval(checkLaunchStatus, 1000);

    return () => clearInterval(timer);
  }, []);

  return isLaunched;
};